import { useState, useEffect } from 'react';
import { CategoryBuckets, QcFlagDisplay, type Category } from '../../shared';

export interface CategoriesData {
  categories: Category[];
  qc_flag_categories: boolean | null;
  qc_flag_categories_notes: string | null;
}

export interface CategoriesSectionProps {
  data: CategoriesData;
  editable: boolean;
  onChange?: (updates: Partial<CategoriesData>) => void;
}

export function CategoriesSection({ data, editable, onChange }: CategoriesSectionProps) {
  const [localData, setLocalData] = useState<CategoriesData>(data);

  useEffect(() => {
    setLocalData(data);
  }, [data]);

  const handleQcChange = (flag: boolean, notes: string) => {
    const updates = {
      ...localData,
      qc_flag_categories: flag,
      qc_flag_categories_notes: notes
    };
    setLocalData(updates);
    onChange?.(updates);
  };

  return (
    <>
      <QcFlagDisplay
        flagged={localData.qc_flag_categories}
        notes={localData.qc_flag_categories_notes}
        editable={editable}
        onChange={handleQcChange}
      />

      <CategoryBuckets categories={localData.categories} expandable={true} />
    </>
  );
}

export default CategoriesSection;
